<template>
  <DbsHeader
    :class="[isBooking ? '' :'using-header']"
    headerTitle="バイク番号を選択してください"
    :isShowBackButton="isBooking"
    :clickBackButtonEvent="backToDbsIndexPage"
  />

  <!-- 選択されたポート名 -->
  <div class="selected-port">{{ parks.park_info.park_name_jp }}</div>

  <!-- サジェスト検索 -->
  <div class="select-cycle">
    <!-- 自転車一覧 -->
    <div class="cycles">
      <div
        v-for="(cycle, index) in cycleInfo"
        :key="index"
        @click="selectCycle(cycle.cyc_name)"
      >
        <div class="cycle">
          <p>{{ cycle.cyc_name }}</p>
          <img :src="require(`@/assets/img/icon/png/dbs/battery_${cycle.battery_level}.png`)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import dbsService from "@/services/dbs";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TemplateDbsSelectCycle",
  components: {},
  setup() {
    const store = useStore();
    const route = useRoute();
    const parks = computed(() => store.getters["dbs/park"]);
    const cycleInfo = computed(() =>
      "cycle_info" in parks.value
        ? dbsService.sortCycleInfo(parks.value.cycle_info)
        : []
    );

    const isBooking = route.query.type == "booking";

    const selectCycle = (cycle_name) => {
      dbsService.goToBookingConfirmation(cycle_name, route.query.type);
    };

    const backToDbsIndexPage = () => {
      nativeHandlerService.returnNativeDbsWithClose();
    };

    return {
      parks,
      cycleInfo,
      isBooking,
      selectCycle,
      backToDbsIndexPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.using-header {
  :deep(h1.heading){
    margin-top: 20px !important;
  }
}
.select-cycle {
  padding: 0 20px;
}
.selected-port {
  margin: 0 0 30px 50px;
  color: #2f2f2f;
}
.search-input {
  width: 100%;
  display: flex;
  align-items: center;
}
.search-input::before {
  content: "";
  width: 1.25rem;
  height: 1.25rem;
  fill: currentColor;
}
.search-input > input {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  width: 80%;
  border-radius: 0.5rem;
  border: 2px solid #ffb206;
}
.cycles {
  padding: 0px 10px;
}
.cycle {
  border-radius: 4px;
  margin: 10px;
  padding: 15px;
  font-size: 14px;
  font-weight: bold;
  background-color: #fae278;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  overflow: hidden;
  p {
    display: inline-block;
    padding-top: 0.2vh;
  }
  img {
    float: right;
    width: 10%;
  }
}
</style>
